import * as  moment from 'moment';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { Router } from '@angular/router';

import { PlycaDataService } from '../../services/plyca.service';
import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';

@Component({
  selector: 'sysTime',
  templateUrl: 'sysTime.template.html'
})
export class sysTimeComponent implements OnInit, OnDestroy {
  @Input() estilos: string; //  = 'style1 bg-azul1';
  @Input() descriptionKey; //  = 'Eventos';
  @Input() icon: string; //  = 'fa-clock-o';
  @Input() layoutClass: string;

  // Referencia a la lista de tareas almacenada en el store
  subscription: Subscription;
  sysTime: Date;
  clockThread: Subscription;

  loading = true;
  error = false;
  empty = false;

  constructor(private store: Store<AppState>,
    public plycaService: PlycaDataService,
    private router: Router) { }

  ngOnInit(): void {
    this.subscription = this.plycaService
      .getAttributeValue('FECHA_ACTUAL_STD')
      .subscribe(result => {
        if (result && result.values && result.values.length > 0) {
          console.log("Hora Servidor: " + result.values[0].columns['FECHAACTUAL'].value);
          this.sysTime = moment(result.values[0].columns['FECHAACTUAL'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
          console.log("Hora Servidor Establecida: " + this.sysTime);
          this.loading = false;
          this.initClockThread();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.stopClockThread();
  }

  initClockThread() {
    if (!this.clockThread) {
      this.clockThread = interval(1000).subscribe(() => {
        this.sysTime = moment(this.sysTime).add(1, 's').toDate();
      });
    }
  }

  stopClockThread() {
    if (this.clockThread) {
      this.clockThread.unsubscribe();
      this.clockThread = undefined;
    }
  }


  getTime(): Date {
    return this.sysTime;
  }

  isLoading(): boolean {
    return this.loading;
  }

  isError(): boolean {
    return this.error;
  }

  isOK(): boolean {
    return !this.loading && !this.error && !this.empty;
  }

  isEmpty(): boolean {
    return this.empty;
  }
}
